
import { Vue, Prop } from "vue-property-decorator";
export default class BsContainerComponent extends Vue {
  @Prop({ default: false }) light!: boolean;
  @Prop({ default: false }) dark!: boolean;
  @Prop({ default: null }) fluid!: boolean;
  @Prop({ default: false }) h100!: boolean;
  @Prop({ type: Number, default: null }) ml: Number;
  @Prop({ type: Number, default: null }) mr: Number;
  @Prop({ type: Number, default: null }) mt: Number;
  @Prop({ type: Number, default: null }) mb: Number;
  @Prop({ type: Number, default: null }) mx: Number;
  @Prop({ type: Number, default: null }) my: Number;
  @Prop({ type: Number, default: null }) pl: Number;
  @Prop({ type: Number, default: null }) pr: Number;
  @Prop({ type: Number, default: null }) pt: Number;
  @Prop({ type: Number, default: null }) pb: Number;
  @Prop({ type: Number, default: null }) px: Number;
  @Prop({ type: Number, default: null }) py: Number;

  GetClass() {
    var css: any = {};
    css.light = this.light;
    css.dark = this.dark;
    css["h-100"] = this.h100;
    css.container = this.fluid == null;
    css["container-fluid"] = this.fluid != null;

    css[`ml-${this.ml}`] = this.ml != null;
    css[`mt-${this.mt}`] = this.mt != null;
    css[`mr-${this.mr}`] = this.mr != null;
    css[`mb-${this.mb}`] = this.mb != null;
    css[`my-${this.my}`] = this.my != null;
    css[`mx-${this.mx}`] = this.mx != null;

    css[`pl-${this.pl}`] = this.pl != null;
    css[`pt-${this.pt}`] = this.pt != null;
    css[`pr-${this.pr}`] = this.pr != null;
    css[`pb-${this.pb}`] = this.pb != null;
    css[`py-${this.py}`] = this.py != null;
    css[`px-${this.px}`] = this.px != null;
    return css;
  }
}
